export default {
  "agent_install_status_missing": "Installation status is no longer available. The gateway may have restarted; check installed agents and retry.",
  "agent_install_failed": "Installation failed. Check the gateway logs for details.",
  "billing_disabled": "Hosted billing is disabled.",
  "telegram_billing_unavailable": "Telegram billing is not configured.",
  "subscription_exists": "A paid subscription is already active.",
  "telegram_billing_unlinked": "Telegram account is not linked.",
  "telegram_invoice_failed": "Telegram invoice could not be created.",
  "stripe_unavailable": "Stripe billing is not configured.",
  "invalid_plan": "Choose a valid plan.",
  "stripe_subscription_exists": "Use subscription change for existing Stripe subscriptions.",
  "stripe_checkout_failed": "Stripe checkout could not be started.",
  "stripe_subscription_missing": "No Stripe subscription is active.",
  "stripe_change_failed": "Stripe subscription could not be changed.",
  "stripe_change_cancel_failed": "Scheduled Stripe change could not be canceled.",
  "stripe_schedule_missing": "No scheduled plan change is active.",
  "auto_renew_invalid": "Invalid auto-renewal setting.",
  "subscription_missing": "No paid subscription is active.",
  "stripe_renew_failed": "Stripe subscription could not be updated.",
  "stars_charge_missing": "Telegram Stars subscription charge is missing.",
  "telegram_account_invalid": "Telegram account id is invalid.",
  "stars_renew_failed": "Telegram Stars subscription could not be updated.",
  "stripe_customer_missing": "Stripe customer is not available yet.",
  "stripe_portal_failed": "Stripe billing portal could not be started.",
  "telegram_account_unlinked": "This Telegram account is not linked to a chatcode account yet.",
  "telegram_session_expired": "Telegram session expired. Reopen this Mini App from the bot.",
  "telegram_authorization_failed": "Failed to authorize this Mini App session.",
  "load_plans_failed": "Failed to load plans",
  "load_devices_failed": "Failed to load signed-in devices",
  "checkout_failed": "Failed to start Stripe checkout",
  "subscription_switch_failed": "Failed to switch Stripe subscription",
  "cancel_change_failed": "Failed to cancel scheduled plan change",
  "subscription_update_failed": "Failed to update subscription",
  "billing_portal_failed": "Failed to open Stripe billing portal",
  "load_install_failed": "Failed to load install command",
  "telegram_unlink_failed": "Failed to unlink Telegram",
  "do_unlink_failed": "failed to unlink DigitalOcean",
  "revoke_device_failed": "Failed to revoke device session",
  "revoke_devices_failed": "Failed to revoke other devices",
  "load_servers_failed": "Failed to load servers",
  "load_sessions_failed": "Failed to load sessions",
  "create_session_failed": "Failed to create session",
  "end_session_failed": "Failed to end session",
  "rename_server_failed": "Failed to rename server",
  "rename_session_failed": "Failed to rename session",
  "create_server_failed": "Failed to create VPS",
  "created_server_missing": "VPS created but id could not be resolved",
  "server_name_required": "Enter a server name before generating the install command.",
  "generate_install_failed": "Failed to generate manual install command",
  "load_do_options_failed": "Failed to load current DigitalOcean options",
  "power_on_failed": "Failed to power on server",
  "power_off_failed": "Failed to power off server",
  "destroy_server_failed": "Failed to destroy server",
  "remove_server_failed": "Failed to remove server",
  "update_gateway_failed": "Failed to update gateway",
  "load_telegram_server_failed": "Failed to load server sessions.",
  "refresh_sessions_failed": "Failed to refresh sessions.",
  "request_gateway_update_failed": "Failed to request gateway update.",
  "create_telegram_session_failed": "Failed to create session.",
  "open_telegram_session_failed": "Failed to open Telegram session.",
  "server_telegram_only": "Open this server from the Telegram bot.",
  "server_telegram_unavailable": "This server is unavailable for your Telegram account.",
  "session_telegram_only": "Open terminal in the Telegram bot.",
  "session_telegram_unavailable": "This session is unavailable for your Telegram account.",
  "load_terminal_details_failed": "Failed to load terminal session details.",
  "clipboard_unavailable": "Clipboard API unavailable",
  "preview_unavailable": "Preview unavailable.",
  "file_reference_unavailable": "File reference cannot be opened.",
  "link_unavailable": "Link cannot be opened.",
  "not_found": "not_found",
  "unauthorized": "unauthorized",
  "forbidden": "forbidden",
  "rate_limited": "rate limit exceeded",
  "invalid_request": "invalid JSON body",
  "invalid_workdir": "invalid workdir",
  "session_closed": "session is not open",
  "agent_unavailable": "agent not installed",
  "gateway_timeout": "gateway command timed out",
  "file_too_large": "file too large",
  "file_not_found": "file not found",
  "transfer_failed": "Transfer failed",
  "unexpected": "Unexpected error",
  "voice_upgrade_failed": "Upgrade could not be started.",
  "voice_too_short": "Recording is too short.",
  "voice_empty": "Transcription empty.",
  "voice_microphone_denied": "Microphone permission denied.",
  "voice_microphone_missing": "No microphone found.",
  "voice_microphone_busy": "Microphone is already in use.",
  "voice_microphone_unavailable": "Microphone unavailable.",
  "voice_transcription_failed": "Transcription failed.",
  "voice_not_configured": "Voice transcription is not configured on this deployment.",
  "voice_link_required": "Sign in and link Telegram before using voice transcription.",
  "voice_plan_required": "Voice transcription is available on Starter and higher plans.",
  "survey_load_failed": "Failed to load onboarding",
  "survey_save_failed": "Failed to save onboarding",
  "survey_incomplete": "Please answer every question before finishing.",
  "invalid_email": "Enter a valid email address.",
  "bot_check_required": "Complete the bot check first.",
  "bot_check_failed": "The bot check failed or expired. Please try again.",
  "email_unavailable": "Email sign-in is temporarily unavailable.",
  "auth_send_failed": "Failed to send the sign-in link. Please try again.",
  "telegram_not_linked": "Telegram is not linked to a chatcode account yet. Sign in first, then link Telegram from the app.",
  "account_mismatch": "This sign-in link belongs to a different account. Open it in a signed-out browser or switch accounts first.",
  "oauth_browser_mismatch": "This sign-in was finished in a different browser than the one that started it. Start again here.",
  "unknown": "Something went wrong: {{detail}}",
  "network": "Could not reach the server. Please try again.",
  "gateway_offline": "The server is reconnecting. Please try again shortly.",
  "session_not_found": "This session is no longer available.",
  "preferences_invalid_locale": "Choose a supported language.",
  "preferences_save_failed": "Could not save your preferences. Please try again."
} as const;
